import React, {Component} from 'react'
import {extend} from 'lodash'
import {
    ActionBar,
    ActionBarRow,
    GroupedSelectedFilters,
    HierarchicalMenuFilter,
    HitsStats,
    Layout,
    LayoutBody,
    LayoutResults,
    NoHits, PageSizeSelector, Tabs,
    Pagination,
    RangeFilter,
    RefinementListFilter,
    ResetFilters,
    SearchBox,
    SearchkitManager,
    SearchkitProvider,
    SideBar,
    SortingSelector,
    TopBar,
    ViewSwitcherHits,
    ViewSwitcherToggle
} from 'searchkit'
import './index.css'

// const host = "http://localhost:9200/recipes_index_custom/recipes"
const host = "http://recipe-search-api-prod.eu-west-2.elasticbeanstalk.com/v1/recipes_skits"
// const host = "http://localhost:8085/v1/recipes_skits"
const searchkit = new SearchkitManager(host)

const RecipeHitsGridItem = (props)=> {
  const {bemBlocks, result} = props
  let url = result._source.url
  const source:any = extend({}, result._source, result.highlight)
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <a href={url} target="_blank">
        <img data-qa="poster" alt="cool image should be here"
             className={bemBlocks.item("poster")}
             src={result._source.image}
             onError={event => event.target.src="img/image-not-yet-available_white.png"}
             width="240" height="140"
        />
        <div data-qa="title" className={bemBlocks.item("title")} dangerouslySetInnerHTML={{__html:source.name}}></div>
      </a>
    <h3 className={bemBlocks.item("subtitle")}>
        Prep min {result._source.prepTimeInMinutes} | Cook min: {result._source.cookTimeInMinutes}
    </h3>
    <h3 className={bemBlocks.item("subtitle")}>
        Source: <a href={url} target="_blank">{result._source.source}</a>
    </h3>
    </div>
  )
}

const RecipeHitsListItem = (props)=> {
  const {bemBlocks, result} = props
    let url = result._source.url
  const source:any = extend({}, result._source, result.highlight)
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <div className={bemBlocks.item("poster")}>
        <img data-qa="poster" alt="cool image should be here"
             src={result._source.image}
             onError={event => event.target.src="img/image-not-yet-available_white.png"}
        />
      </div>
      <div className={bemBlocks.item("details")}>
        <a href={url} target="_blank"><h2 className={bemBlocks.item("title")} dangerouslySetInnerHTML={{__html:source.name}}></h2></a>
        <h3 className={bemBlocks.item("subtitle")}>
            Prep time: {result._source.prepTimeInMinutes}mins | {' '}
            Cook time: {result._source.cookTimeInMinutes}mins | {' '}
            {/*First Seen on {result._source.seen}*/}
             Source: <a href={url} target="_blank">{result._source.source}</a>
        </h3>
        <div className={bemBlocks.item("description")} dangerouslySetInnerHTML={{__html:source.description}}></div>
        <br/>
        <div className={bemBlocks.item("ingredients")} dangerouslySetInnerHTML={{__html: "<span class='ingredient-lbl'>Ingredients: </span>" + source.ingredients}}></div>
      </div>
    </div>
  )
}

class App extends Component {
  render() {
    return (
      <SearchkitProvider searchkit={searchkit}>
        <Layout>
          <TopBar>
            <div className="my-logo">Vegily</div>
            <SearchBox autofocus={true} searchOnChange={true}
                       prefixQueryFields={["ingredients^10","description^2","name^4"]}
                       placeholder={"Enter ingredients or recipe name to search for"}/>
          </TopBar>

        <LayoutBody>

          <SideBar>
            <HierarchicalMenuFilter fields={["source.raw"]} title="Sources" id="source"/>
              <hr/>
            <RangeFilter  min={0} max={120} field="prepTimeInMinutes" id="prepTimeInMinutes" title="Prep times" showHistogram={true}/>
            <RangeFilter min={0} max={120} field="cookTimeInMinutes" id="cookTimeInMinutes" title="Cook times" showHistogram={true}/>
            <RefinementListFilter id="difficulty" title="Difficulty" field="difficulty.raw" operator="OR" size={10}/>
            {/*<InputFilter id="writers" searchThrottleTime={500} title="Writers" placeholder="Search writers" searchOnChange={true} queryFields={["writers"]} />*/}
            {/*<RefinementListFilter id="actors" title="Actors" field="actors.raw" size={10}/>*/}
            {/*<RefinementListFilter translations={{"facets.view_more":"View more writers"}} id="writers" title="Writers" field="writers.raw" operator="OR" size={10}/>*/}
            {/*<DynamicRangeFilter field="prepTimeInMinutes" id="prepTimeInMinutes_test" title="Prep time dynamic" rangeFormatter={(count)=> count + "*"} showHistogram={true}/>*/}

              {/* TODO: enable to use NumericRefinementListFilter instead of Rangefilter for cook times*/}
              {/*<NumericRefinementListFilter id="prepTimeInMinutes_refinement" title="Prep time" field="prepTimeInMinutes" options={[*/}
              {/*{title:"All"},*/}
              {/*{title:"up to 15 mins", from:0, to:15},*/}
              {/*{title:"up to 25 mins", from:0, to:25},*/}
              {/*{title:"15 to 30 mins", from:15, to:30},*/}
              {/*{title:"30 to 60 mins", from:30, to:60},*/}
              {/*{title:"1hr +", from:61, to:1000}*/}
            {/*]}/>*/}
          </SideBar>
          <LayoutResults>
            <ActionBar>

              <ActionBarRow>

                  <SortingSelector options={[
                      {label:"Most relevant", field:"_score", order:"desc"},
                      {label:"Quickest first", field:"cookTimeInMinutes", order:"asc"},
                      {label:"Longest first", field:"cookTimeInMinutes", order:"desc"}
                  ]} listComponent={Tabs} />


                <HitsStats translations={{
                  "hitstats.results_found":"{hitCount} results found"
                }}/>
                <ViewSwitcherToggle/>

                  <PageSizeSelector options={[10,20,50]}  />

              </ActionBarRow>
                <ActionBarRow>
                <GroupedSelectedFilters/>
                <ResetFilters/>
              </ActionBarRow>

            </ActionBar>
            <ViewSwitcherHits
                hitsPerPage={25} highlightFields={["name","description", "ingredients"]}
                sourceFilter={["source", "difficulty", "prepTimeInMinutes", "cookTimeInMinutes", "url", "image", "ingredients", "name", "description"]}
                hitComponents={[
                  {key:"grid", title:"Grid", itemComponent:RecipeHitsGridItem, defaultOption:true},
                  {key:"list", title:"List", itemComponent:RecipeHitsListItem}
                ]}
                scrollTo="body"
            />
          <NoHits translations = {{
              "NoHits.NoResultsFound":"Vegily could not find recipes for {query}.",
              "NoHits.NoResultsFoundDidYouMean":"Vegily could not find recipes for {query}. Did you mean {suggestion}?",
              "NoHits.DidYouMean":"Search for {suggestion} instead",
              "NoHits.SearchWithoutFilters":"Search for {query} without filters",
              "NoHits.Error":"We're sorry, Vegily got in a pickle fetching your recipes. Please try again.",
              "NoHits.ResetSearch":"Reset Recipe Search"
          }} suggestionsField={"ingredients"}/>

            <Pagination showNumbers={true}/>
          </LayoutResults>

          </LayoutBody>
        </Layout>
      </SearchkitProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js